import { RootState } from "@app/store";
import { SpinLoading } from "antd-mobile";
import { useSelector } from "react-redux";

export default function MainLoading() {
  const loading = useSelector((state: RootState) => state.share.loading)

  if (!loading) return <></>

  return (
    <div className="fixed top-0 bottom-0 right-0 left-0 m-auto flex justify-center items-center z-50">
      <SpinLoading style={{ '--size': '48px', '--color': '#FB2D5A' }} />
    </div>
  )
}